<template>
  <div class="NewsFooter">

    <div class="NewsFooter-search">

      <news-search />

    </div>

  </div>
</template>

<script>
export default {
  name: 'NewsFooter'
}
</script>

<style>
.NewsFooter {

}

.NewsFooter-search {
  margin-top: 48px;

  @media (min-width: 600px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// NewsFooter.vue?8b1ad050